var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetaMaskLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CDBDB2",
    fillRule: "evenodd",
    d: "m15.89 38.083 4.94 1.355v-1.771l.403-.417h2.823v3.542h-3.025l-3.73-1.667-1.412-1.042Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CDBDB2",
    fillRule: "evenodd",
    d: "m32.021 38.083-4.84 1.355v-1.771l-.403-.417h-2.823v3.542h3.025l3.73-1.667 1.311-1.042Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    fillRule: "evenodd",
    d: "m21.233 34.23-.403 3.437.504-.417h5.243l.605.417-.404-3.438-.806-.52-4.033.104-.706.416Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F89C35",
    fillRule: "evenodd",
    d: "m18.51 11 2.42 5.833 1.11 16.98h3.932l1.21-16.98L29.4 11H18.51Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F89D35",
    fillRule: "evenodd",
    d: "M7.924 23.813 5.101 32.25l7.058-.417h4.537v-3.645l-.202-7.5-1.008.833-7.562 2.292Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D87C30",
    fillRule: "evenodd",
    d: "m13.268 24.75 8.267.208-.907 4.375-3.932-1.041-3.428-3.542Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA8D3A",
    fillRule: "evenodd",
    d: "m13.268 24.854 3.428 3.334v3.333l-3.428-6.667Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F89D35",
    fillRule: "evenodd",
    d: "m16.696 28.292 4.033 1.041 1.31 4.48-.907.52-4.436-2.708v-3.333Z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB8F35",
    fillRule: "evenodd",
    d: "m16.696 31.625-.807 6.458 5.344-3.854-4.537-2.604Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA8E3A",
    fillRule: "evenodd",
    d: "m21.535 24.958.505 8.855-1.513-4.532 1.008-4.323Z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#D87C30",
    fillRule: "evenodd",
    d: "m12.058 31.73 4.638-.105-.807 6.458-3.831-6.354Z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB8F35",
    fillRule: "evenodd",
    d: "m7.32 40.896 8.57-2.813-3.832-6.354-6.957.521 2.218 8.646Z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8821E",
    fillRule: "evenodd",
    d: "m20.93 16.833-4.335 3.75-3.327 4.167 8.267.313-.605-8.23Z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFCEC3",
    fillRule: "evenodd",
    d: "m15.89 38.083 5.343-3.854-.403 3.334v1.875l-3.63-.73-1.31-.625Zm16.131 0-5.243-3.854.404 3.334v1.875l3.63-.73 1.21-.625Z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    fillRule: "evenodd",
    d: "m19.317 26.833 1.11 2.396-3.933-1.041 2.823-1.355Z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F35",
    fillRule: "evenodd",
    d: "m7.218 6.104 13.712 10.73L18.611 11 7.218 6.104Z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#8E5A30",
    fillRule: "evenodd",
    d: "m7.218 6.104-1.815 5.73 1.009 6.25-.706.416 1.008.938-.807.729 1.11 1.041-.706.625 1.613 2.084 7.562-2.396c3.697-3.056 5.512-4.618 5.444-4.688-.067-.07-4.638-3.645-13.712-10.729Z",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#F89D35",
    fillRule: "evenodd",
    d: "m39.986 23.813 2.823 8.437-7.057-.417h-4.537v-3.645l.201-7.5 1.009.833 7.561 2.292Z",
    clipRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#D87C30",
    fillRule: "evenodd",
    d: "m34.643 24.75-8.268.208.907 4.375 3.933-1.041 3.428-3.542Z",
    clipRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA8D3A",
    fillRule: "evenodd",
    d: "m34.643 24.854-3.428 3.334v3.333l3.428-6.667Z",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#F89D35",
    fillRule: "evenodd",
    d: "m31.215 28.292-4.033 1.041-1.311 4.48.907.52 4.437-2.708v-3.333Z",
    clipRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB8F35",
    fillRule: "evenodd",
    d: "m31.215 31.625.806 6.458-5.243-3.75 4.437-2.708Z",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA8E3A",
    fillRule: "evenodd",
    d: "m26.375 24.958-.504 8.855 1.512-4.532-1.008-4.323Z",
    clipRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#D87C30",
    fillRule: "evenodd",
    d: "m35.853 31.73-4.638-.105.806 6.458 3.832-6.354Z",
    clipRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB8F35",
    fillRule: "evenodd",
    d: "m40.591 40.896-8.57-2.813 3.832-6.354 6.956.521-2.218 8.646Z",
    clipRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8821E",
    fillRule: "evenodd",
    d: "m26.98 16.833 4.335 3.75 3.328 4.167-8.268.313.605-8.23Z",
    clipRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    fillRule: "evenodd",
    d: "m28.593 26.833-1.109 2.396 3.932-1.041-2.823-1.355Z",
    clipRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F35",
    fillRule: "evenodd",
    d: "M40.692 6.104 26.98 16.834 29.299 11l11.393-4.896Z",
    clipRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#8E5A30",
    fillRule: "evenodd",
    d: "m40.692 6.104 1.815 5.73-1.008 6.25.706.416-1.009.938.807.729-1.11 1.041.707.625-1.614 2.084-7.561-2.396c-3.697-3.056-5.512-4.618-5.445-4.688.067-.07 4.638-3.645 13.712-10.729Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaMaskLogo);
export default __webpack_public_path__ + "static/media/metaMaskLogo.0455ce19e1d8cfac5ea5efbf9076e20e.svg";
export { ForwardRef as ReactComponent };